import ContractMdl from '@/models/HumanResource/HrContract'
export default async contractId => {
    try {
        let contract = await ContractMdl.find(contractId)
        let response = await contract.delete()
        return response.data
    } catch (error) {
        return error.response.data
    }
}
